import React from 'react';
import { Pressable } from 'react-native';
import { StyleSheet, View } from 'react-native';
import {
  BodyText,
  HStack,
  theme,
  useBreakpointHelpers,
  VStack,
} from '@sg/garnish';

import { SweetpassBenefitCard } from '../SweetpassUpgradeScreen/SweetpassBenefitCard';
import { getSweetpassBenefitsScreenBenefitPaletteForTag } from './SweetpassBenefitScreenPalette';
import type {
  SweetpassBenefitList,
  SweetpassBenefitsPageBenefitCtaHandler,
} from './SweetpassBenefitsScreen.loaded';

export const SweetpassBenefitsPageBenefitsContent = ({
  content,
  ctaHandler,
}: SweetpassBenefitsPageBenefitsContentProps) => {
  const { isMobile } = useBreakpointHelpers();
  const DynamicStack = isMobile ? VStack : HStack;

  return (
    <View style={styles.container}>
      <BodyText size={1} style={styles.benefitTitle}>
        {content.title}
      </BodyText>
      <DynamicStack
        testID={`sweetpass-benefits-page-benefits-list-wrapper${
          isMobile ? '-mobile' : ''
        }`}
        itemsPerRow={3}
        itemStyle={styles.alignItemsCenter}
        dividerColor={theme.colors.LIGHT}
        divider
      >
        {content.benefits.map((benefit) =>
          benefit.action ? (
            <Pressable
              testID={`sweetpass-benefits-page-benefit-${benefit.id}-cta`}
              key={benefit.id}
              accessibilityRole="button"
              onPress={() => {
                ctaHandler(benefit.action);
              }}
            >
              <SweetpassBenefitCard
                content={benefit}
                palette={getSweetpassBenefitsScreenBenefitPaletteForTag(
                  content.palette,
                )}
              />
            </Pressable>
          ) : (
            <SweetpassBenefitCard
              key={benefit.id}
              content={benefit}
              palette={getSweetpassBenefitsScreenBenefitPaletteForTag(
                content.palette,
              )}
            />
          ),
        )}
      </DynamicStack>
    </View>
  );
};

type SweetpassBenefitsPageBenefitsContentProps = {
  readonly content: SweetpassBenefitList;
  readonly ctaHandler: SweetpassBenefitsPageBenefitCtaHandler;
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing.xlarge,
  },
  alignItemsCenter: {
    alignItems: 'center',
  },
  benefitTitle: {
    paddingBottom: theme.spacing.small,
    marginBottom: theme.spacing.medium,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.NEUTRAL_3,
    color: theme.colors.GREEN_1,
  },
});
